var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "no-permission-wrapper" }, [
    _c(
      "span",
      { attrs: { id: _vm.id, tabindex: "0" } },
      [
        _vm._t("default"),
        _vm._v(" "),
        _vm.show
          ? _c("no-permission-tooltip", { attrs: { target: _vm.id } })
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }